import { RaidPlanAssignmentEntity } from 'app/frontend/types/custom/RaidPlan'
import getAssignmentEntityIdentity from './assignmentEntityIdentity'

export const ASSIGNMENT_SIDEBAR_BREAKPOINT = 1024

export const getAssignedEntityId = (
  entity: RaidPlanAssignmentEntity,
  index: number,
) => entity.id ?? `anon-${getAssignmentEntityIdentity(entity)}-${index}`

export type FocusedAssignmentScope = {
  abilityKey: string
  scopeId: string
  groupIndex: number
}

export type AssignmentGroupLocation = {
  abilityKey: string
  scopeId: string
  groupIndex: number
}

const ABILITY_ROW_PREFIX = 'ability-row/'
const PALETTE_PREFIX = 'palette/'
const ASSIGNED_PREFIX = 'assigned/'
const GROUP_PREFIX = 'group/'

export const getAbilityRowDragId = (abilityKey: string) =>
  `${ABILITY_ROW_PREFIX}${abilityKey}`

export const parseAbilityRowDragId = (id: string) => {
  if (!id.startsWith(ABILITY_ROW_PREFIX)) return null
  return id.slice(ABILITY_ROW_PREFIX.length)
}

export const getPaletteDragId = (paletteId: string) =>
  `${PALETTE_PREFIX}${paletteId}`

export const parsePaletteDragId = (id: string) => {
  if (!id.startsWith(PALETTE_PREFIX)) return null
  return id.slice(PALETTE_PREFIX.length)
}

export const getAssignedChipId = (
  abilityKey: string,
  scopeId: string,
  groupIndex: number,
  entityId: string,
) => `${ASSIGNED_PREFIX}${abilityKey}/${scopeId}/${groupIndex}/${entityId}`

export const parseAssignedChipId = (
  id: string,
): (AssignmentGroupLocation & { entityId: string }) | null => {
  if (!id.startsWith(ASSIGNED_PREFIX)) return null
  const [abilityKey, scopeId, groupIndexValue, entityId] = id
    .slice(ASSIGNED_PREFIX.length)
    .split('/')
  const groupIndex = Number(groupIndexValue)
  if (!abilityKey || !scopeId || !entityId || Number.isNaN(groupIndex)) {
    return null
  }
  return { abilityKey, scopeId, groupIndex, entityId }
}

export const getGroupDroppableId = (
  abilityKey: string,
  scopeId: string,
  groupIndex: number,
) => `${GROUP_PREFIX}${abilityKey}/${scopeId}/${groupIndex}`

export const parseGroupDroppableId = (
  id: string,
): AssignmentGroupLocation | null => {
  if (!id.startsWith(GROUP_PREFIX)) return null
  const [abilityKey, scopeId, groupIndexValue] = id
    .slice(GROUP_PREFIX.length)
    .split('/')
  const groupIndex = Number(groupIndexValue)
  if (!abilityKey || !scopeId || Number.isNaN(groupIndex)) return null
  return { abilityKey, scopeId, groupIndex }
}

export const parseAssignmentDropLocation = (
  id: string,
): AssignmentGroupLocation | null => {
  const groupLocation = parseGroupDroppableId(id)
  if (groupLocation) return groupLocation
  const chipLocation = parseAssignedChipId(id)
  if (!chipLocation) return null
  return {
    abilityKey: chipLocation.abilityKey,
    scopeId: chipLocation.scopeId,
    groupIndex: chipLocation.groupIndex,
  }
}
